import axios from 'axios';
import jwt_decode from "jwt-decode";

//const BASE_URL = 'https://wolt.dev.softexpres.com/api'
//const BASE_URL = 'http://192.168.0.122:6567/api'
const BASE_URL = 'https://cloudsoftexpres.com:3001/api'
const token = localStorage.getItem("token") ? localStorage.getItem("token") : null
const refreshToken = localStorage.getItem("refreshToken") ? localStorage.getItem("refreshToken") : null

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: { "Authorization": `Bearer ${token}` }
});

let isSending = false

axiosInstance.interceptors.response.use(
    async (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;
                if(!isSending){
                    try {
                        const accessToken = await getRefreshToken();
                        originalConfig.headers.Authorization = `Bearer ${accessToken}`;
                        window.location.href='/home'
                    } catch (_error) {
                        if (_error.response && _error.response.data) {
                            return Promise.reject(_error.response.data);
                        }
    
                        return Promise.reject(_error);
                    }
                }
                
            }

            if (err.response.status === 403 && err.response.data) {
                return Promise.reject(err.response.data);
            }
        }

        return Promise.reject(err)
    }
);

const getRefreshToken = async () => {
    try {
        isSending = true
        const decoded = jwt_decode(token);
        const response = await axios.post(
            `${BASE_URL}/refresh-token/?refreshToken=${refreshToken}&username=${decoded["Username"]}`
        );
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("refreshToken", response.data.newRefreshToken);
        isSending = false
        return response.data.token;
    } catch (err) {
        console.log(err);
        alert("Nododhi nje gabim , ju lutem rilogohuni");
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken"); // Remove the refresh token as it might be expired.
        window.location.href = "/";
        isSending = false
    }
}

export default axiosInstance;